import { VuexModule, Module, getModule, MutationAction, Mutation, Action } from 'vuex-module-decorators';

import store from '@/store';
import { Survey as SurveyModel} from '@/store/models';
import SurveyService from '@/services/SurveyService';

@Module({
	dynamic: true,
	store,
	name: 'survey'
})
class Survey extends VuexModule {
	public survey: SurveyModel | null = null;
	public showActiveQuestion: boolean = false;

	/**
	 * Set weather the active question schoul be displayed.
	 * 
	 * @param show
	 */
	@Mutation
	public setShowActiveQuestion(show: boolean) {
		this.showActiveQuestion = show;
	}

	/**
	 * Load survey data.
	 * 
	 * @param surveyId
	 */
	@MutationAction
	public async loadSurvey(surveyId: number) {
		const survey = await SurveyService.getInstance().getSurvey(surveyId);
		return { survey };
	}
}

export const SurveyModule = getModule(Survey);
